/* eslint-disable react/prefer-stateless-function */
/* eslint-disable no-plusplus */
/* eslint-disable no-underscore-dangle */

// eslint-disable-next-line simple-import-sort/imports
import React from 'react';
import { selectCurrentSalonCurrencySign, selectCurrentSalonId } from 'selectors/currentSalon.selectors';
import { ColumnChart } from 'react-chartkick';
import 'chartjs-plugin-style';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { ColorLegend } from 'reports/DashboardReports/Charts/common/ColorLegend';
import Container from 'reports/DashboardReports/Charts/common/Container';
import LegendContainer from 'reports/DashboardReports/Charts/common/LegendContainer';
import { convertToMoneyAfterVat } from 'reports/utils';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import fixed from 'utils/values/fixed.util';
import { useTranslation } from 'providers/GILT.provider';

const RevenueColumnChart = ({ forecastSales, actualSales, currentSalonSign, salonId, salesToDate, forecastSalesTotal }) => {
  const { t } = useTranslation();

  const indigo = 'rgba(62, 11, 108, 0.9)';
  const violet = 'rgba(227, 191, 245, 0.9)';

  const data = [
    {
      name: t('businessReports.weekly.chartBar1'),
      data: forecastSales,
    },
    {
      name: t('businessReports.weekly.chartBar2'),
      data: actualSales,
    },
  ];

  const currencyAbbr = currentSalonSign;

  const legendItems = [
    {
      text: t('businessReports.weekly.legendTitle1'),
      val: `${currencyAbbr}${fixed(convertToMoneyAfterVat(salesToDate))}`,
    },
    {
      text: t('businessReports.weekly.legendTitle2'),
      val: `${currencyAbbr}${fixed(convertToMoneyAfterVat(forecastSalesTotal))}`,
    },
  ];

  const chartDataset = {
    borderColor: 'transparent',
    categorySpacing: 0,
    borderWidth: 0,
    barPercentage: 0.9, // 1.0 will take the whole category width - not working
  };

  const chartConfig = {
    legendCallback(chart) {
      const text = [];
      text.push(`<ul class='${chart.id}-legend'>`);
      for (let i = 0; i < chart.data.datasets.length; i++) {
        text.push(`<li><span style='background-color:${chart.data.datasets[i].backgroundColor}'></span>`);
        if (chart.data.datasets[i].label) {
          text.push(chart.data.datasets[i].label);
        }
        text.push('</li>');
      }

      text.push('</ul>');
      return text.join('');
    },
    animation: { easing: 'easeOutQuad' },
    tooltips: {
      enabled: true,
      backgroundColor: '#192340',
      titleFontSize: 15,
      titleFontStyle: '900',
      titleFontFamily: 'ProximaNova-b',
      titleFontColor: 'white',
      caretSize: 7,
      yPadding: 12,
      xPadding: 14,
      bodyFontFamily: 'ProximaNova-r',
      bodyFontSize: 16,
      borderColor: '#192340',
      shadowOffsetX: 3,
      shadowOffsetY: 3,
      shadowBlur: 10,
      shadowColor: 'rgba(0, 0, 0, 0.5)',
    },
    scales: {
      xAxes: [
        {
          ticks: {
            fontColor: '#979797',
            fontFamily: 'ProximaNova-r',
            fontSize: 13,
          },

          barPercentage: 1,
          gridLines: {
            color: '#FFFFFF',
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            fontColor: '#979797',
            fontFamily: 'ProximaNova-r',
            fontSize: 13,
            callback(value) {
              return `${currencyAbbr}${value}`;
            },
          },
          gridLines: {
            color: '#F4F4F4',
          },
        },
      ],
    },
  };

  return (
    <Container chartName={t('businessReports.weekly.revenueChartTitle')} chartDescription="">
      <LegendContainer dot={false} items={legendItems} />
      <NavLink to={`/salon/${salonId}/communications/marketing`} onClick={alwaysNoop} className="btn btn-violet btn-report in-dashboard">
        {t('businessReports.weekly.getMoreBookings')}
      </NavLink>

      <ColorLegend />

      <ColumnChart legend={false} prefix={currencyAbbr} data={data} download colors={[violet, indigo]} dataset={chartDataset} stacked={false} library={chartConfig} />
    </Container>
  );
};

const mapStateToProps = (state) => ({
  currentSalonSign: selectCurrentSalonCurrencySign(state),
  salonId: selectCurrentSalonId(state),
});

export default connect(mapStateToProps)(RevenueColumnChart);
